import { useState } from "react";
import { Tab } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { AudienceTab } from "./AudienceTab";
import { ComingSoon } from "./ComingSoon";

const i18nRoot = "admin_dashboard.analytics";

type TabId =
  | "audience"
  | "engagement"
  | "broadcast"
  | "website"
  | "payments"
  | "discover";

interface TabConfig {
  component: React.ComponentType;
  id: TabId;
  label: string;
}

const tabs: TabConfig[] = [
  {
    id: "audience",
    label: t([i18nRoot, "tabs", "audience"]),
    component: AudienceTab,
  },
  {
    id: "engagement",
    label: t([i18nRoot, "tabs", "engagement"]),
    component: ComingSoon,
  },
  {
    id: "broadcast",
    label: t([i18nRoot, "tabs", "broadcast"]),
    component: ComingSoon,
  },
  {
    id: "website",
    label: t([i18nRoot, "tabs", "website"]),
    component: ComingSoon,
  },
  {
    id: "payments",
    label: t([i18nRoot, "tabs", "payments"]),
    component: ComingSoon,
  },
  {
    id: "discover",
    label: t([i18nRoot, "tabs", "discover"]),
    component: ComingSoon,
  },
];

export const YourOverview = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div>
      <div className="pb-4">
        <Typography.TitleSm weight="semibold">
          {t([i18nRoot, "title"])}
        </Typography.TitleSm>
      </div>

      <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        <Tab.List className="flex gap-1">
          {tabs.map(tab => (
            <Tab
              key={tab.id}
              className={({ selected }) =>
                classNames(
                  "rounded-full px-3 py-1.5 text-sm font-medium focus:outline-none",
                  selected
                    ? "bg-secondary text-dark"
                    : "text-light hover:text-default",
                )
              }
            >
              {tab.id === "discover" ? (
                <span className="flex items-center gap-1">
                  {tab.label}
                  <Icon type="16-plus" size={16} className="text-success" />
                </span>
              ) : (
                tab.label
              )}
            </Tab>
          ))}
        </Tab.List>

        <Tab.Panels className="border-primary mt-4 rounded-lg border p-6">
          {tabs.map(tab => (
            <Tab.Panel key={tab.id}>
              <tab.component />
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};
